import type { ValueOf } from "@/shared/types/helperTypes";

export const LOCATION_EXACTNESS_SCOPE = {
    ThisPlace: "0",
    ThisPlaceAdjacent: "0a",
    OneLevelUp: "1",
    OneLevelUpAdjacent: "1a",
    TwoLevelsUp: "2",
    TwoLevelsUpAdjacent: "2a",
    ThreeLevelsUp: "3",
} as const;
export type LocationExactnessScope = ValueOf<typeof LOCATION_EXACTNESS_SCOPE>;
